<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      placeholder="Все заказчики"
      autocomplete="off"
      @input="onQueryInput"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="query" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ item.name }}</div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import customers from "../../network/customers";

export default {
  name: "CustomerSelect",
  mixins: [ customers ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
    selectedName: { type: String, default: '' },
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selectedItem: null,
      configureRequestId: 0,
      searchRequestId: 0,
      searchTimer: null,
    }
  },
  mounted() {
    this.getItems();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && this.selectedItem.name.toLowerCase() === query) return this.items;

      return this.items.filter(item =>
        item.name.toLowerCase().includes(query) || (item.inn || '').toLowerCase().includes(query)
      );
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.configure(newValue);
      }, immediate: true
    },
    selectedName(newValue) {
      if (this.value > 0 && newValue) {
        this.setSelectedItem({ id: this.value, name: newValue });
      }
    },
  },
  methods: {
    async configure(id) {
      const requestId = ++this.configureRequestId;

      if (id && id > 0) {
        if (this.selectedName) {
          this.setSelectedItem({ id: id, name: this.selectedName });
        }

        const result = await this.getCustomerById(id);

        if (requestId !== this.configureRequestId) return;

        if (result && result.data) {
          this.setSelectedItem(result.data);
          return;
        }

        if (this.selectedItem && this.selectedItem.id === id) return;
      }

      this.query = '';
      this.selectedItem = null;
    },
    setSelectedItem(item) {
      this.query = item.name;
      this.selectedItem = item;
    },
    async getItems(query = '') {
      const requestId = ++this.searchRequestId;
      const result = await this.getCustomersSearch(query.trim());

      if (requestId !== this.searchRequestId) return;

      this.items = (result && result.data) ? result.data : [];
    },
    onQueryInput(query) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.getItems(query), 250);
    },
    onFocusIn() {
      this.isFocus = true;
      const query = this.selectedItem && this.query === this.selectedItem.name ? '' : this.query;
      this.getItems(query);
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.selectedItem.name) {
          this.query = this.selectedItem.name;
        }
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onClear() {
      clearTimeout(this.searchTimer);
      this.query = "";
      this.selectedItem = null;
      this.getItems();
      this.$emit('onSelect', 0, null);
    },
    onSelect(item) {
      clearTimeout(this.searchTimer);
      this.setSelectedItem(item);
      this.$emit('onSelect', item.id, item);
      this.onFocusOut();
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerSelect.vue